import { createFileRoute } from '@tanstack/react-router'
import { requireAuthenticated } from '@/shared/lib/route-guards'
import SettingsShellPage from '@/pages/settings/shell'
import GeneralSettingsPage from '@/pages/settings/general'

function SettingsGeneralRoutePage() {
  return (
    <SettingsShellPage activeTab="general">
      <GeneralSettingsPage />
    </SettingsShellPage>
  )
}

export const Route = createFileRoute('/$lang/settings/general')({
  beforeLoad: ({ context, params, location }) => {
    requireAuthenticated(context, params, location.href)
  },
  staticData: { layout: 'main' },
  component: SettingsGeneralRoutePage,
})
